import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild, AfterViewChecked, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { AuthenticationService } from 'app/services';
import { UntypedFormControl } from '@angular/forms';
import { merge, Subject } from 'rxjs';
import { startWith, tap, takeUntil, switchMap } from 'rxjs/operators';
import { BaseService } from 'app/_helpers/base/base.service';

@Component({
  selector: 'app-wg-invoices',
  templateUrl: './wg-invoices.component.html',
  styleUrls: ['./wg-invoices.component.scss'],
  animations: fuseAnimations
})
export class WgInvoicesComponent implements OnInit, AfterViewChecked {

  user: any;
  offices: any;
  invoiceFilter: UntypedFormControl = new UntypedFormControl('outgoing');
  invoiceData: any = [];
  loadingData: boolean;
  @ViewChild('invoicesWidget', { static: false }) private invoicesWidget: ElementRef;
  ownersWidgetChecked: boolean;
  invoiceFilterOptions = {} as any;
  currentAgency: any;


  private _unsubscribeAll: Subject<any>;


  constructor(
    private _gService: BaseService,
    private _authenticationService: AuthenticationService,
    private cdRef: ChangeDetectorRef
  ) {
    this._unsubscribeAll = new Subject();
    this.user = this._authenticationService.currentUserValue;
    this.currentAgency = this._authenticationService.currentAgencyValue._id;
  }

  ngOnInit(): void {

    merge(this.invoiceFilter.valueChanges)
      .pipe(
        startWith('outgoing'),
        tap(() => this.loadingData = true),
        takeUntil(this._unsubscribeAll),
        switchMap((change: string | number) => {
          if (this.invoiceFilter.value && this.invoiceFilter.value === 'incoming') {
            this.invoiceFilterOptions = {
              incoming: true,
            };
          } else if (this.invoiceFilter.value && this.invoiceFilter.value === 'outgoing') {
            this.invoiceFilterOptions = {
              incoming: false,
            };
          }
          if (this.invoicesWidget) {
            this.invoicesWidget.nativeElement.scrollTop = 0;
          }
          return this._gService.post(`invoice`, this.invoiceFilterOptions, 'nodejs');
        })
      )
      .subscribe((data: any) => {
        if (data?.docs) {
          this.invoiceData = data.docs;
        }
        this.loadingData = false;
      }, () => this.loadingData = false);

  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

}
